import { makeStyles } from '@policygenius/mortar';

const styles = makeStyles((theme) => ({
  heading: {
    textAlign: 'center',
    margin: [0, 'auto', theme.spacing('xxlarge')],
  },
  subHeading: {
    marginTop: theme.spacing('medium'),
    textAlign: 'center',
  },
  wrapper: {
    marginLeft: 'auto',
    marginRight: 'auto',
  },
}));

export default styles;
